import React, { createContext, useContext } from 'react';
import { AssessmentContent } from './types';
import { DEFAULT_CONTENT } from './defaults';

/**
 * Provides resolved assessment copy to every screen and panel. Defaults to the
 * built-in content so any component used outside a provider (or before the CMS
 * data loads) still renders correctly.
 */
const AssessmentContentContext = createContext<AssessmentContent>(DEFAULT_CONTENT);

interface ProviderProps {
  content: AssessmentContent;
  children: React.ReactNode;
}

export const AssessmentContentProvider: React.FC<ProviderProps> = ({ content, children }) => (
  <AssessmentContentContext.Provider value={content}>{children}</AssessmentContentContext.Provider>
);

export const useAssessmentContent = (): AssessmentContent => useContext(AssessmentContentContext);
